import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@env/environment';
import {map, Observable} from 'rxjs';
import {Page} from '../domain/page';
import {Customer} from '../domain/customer';

@Injectable({
    providedIn: 'root'
})
export class CustomerService {

    baseUrl: string = environment.endpointApi;

    constructor(private http: HttpClient) {
    }

    findDistinctsCustomers(): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/different-customers`);
    }

    findAllPageC(params: string): Observable<Page<Customer>> {
        return this.findAllC(params) as Observable<Page<Customer>>;
    }

    findAllPageWithLoyalty(params: string): Observable<Page<Customer>> {
        const queryParams = params ? `${params}&loyalty=true` : 'loyalty=true';
        return this.findAllPageC(queryParams);
    }

    findAllC(params: string): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/customers?${params}`);
    }

    findAllCustomersByMonthBirth(params: string): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/customers/operations/events-by-birth?${params}`);
    }

    findById(id: number): Observable<Customer> {
        return this.http.get<Customer>(`${this.baseUrl}/customers/${id}`);
    }

    findByTelefono(telefono: string): Observable<Customer | null> {
        return this.http.get<Customer | null>(
            `${this.baseUrl}/customers/operations/by-phone?telefono=${encodeURIComponent(telefono)}`
        );
    }

    findByDocumento(tipoDocumento: string, numeroDocumento: string): Observable<Customer | null> {
        const params = [
            'paginacion=false',
            `filtro=${encodeURIComponent(numeroDocumento)}`,
            'limit=20',
            `tipoDocumento=${encodeURIComponent(tipoDocumento)}`
        ];
        return this.findAllC(params.join('&')).pipe(
            map((customers: Customer[]) => (customers || []).find(customer =>
                `${customer?.tipoDocumento || ''}` === `${tipoDocumento}`
                && `${customer?.numeroDocumento || ''}` === `${numeroDocumento}`
            ) || null)
        );
    }

    save(model: Customer): Observable<Customer> {
        return this.http.post<Customer>(`${this.baseUrl}/customers`, model);
    }

    importFromExcel(formData): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/customers/operations/import`, formData);
    }

    downloadImportTemplate(): Observable<Blob> {
        return this.http.get(`${this.baseUrl}/customers/import/template`, {responseType: 'blob'});
    }

    update(model: Customer): Observable<Customer> {
        return this.http.put<Customer>(`${this.baseUrl}/customers`, model);
    }

    updatePorDefecto(id, model: Customer): Observable<Customer> {
        return this.http.patch<Customer>(`${this.baseUrl}/customers/${id}/default`, model);
    }


    deleteById(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/customers/${id}`);
    }

}
